import { render, staticRenderFns } from "./CompleteRegistrationPage.vue?vue&type=template&id=d9313092&scoped=true&"
import script from "./CompleteRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./CompleteRegistrationPage.vue?vue&type=script&lang=js&"
import style0 from "./CompleteRegistrationPage.vue?vue&type=style&index=0&id=d9313092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9313092",
  null
  
)

export default component.exports